import React, { useEffect, useState } from "react";
import { dispatch } from "store";
import StockListCommons from "../StockListCommons";
import {
  distributorStockSelector,
  getDistributorStockThunk,
} from "store/reducers/inventory/stock/distributorStockSlice";
import { useSelector } from "react-redux";
import TransferDistributorStock from "./menu/TransferDistributorStock";
import ReturnDistributorStock from "./menu/ReturnDistributorStock";
import { Box, Button, Stack } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import { getDistributorThunk } from "store/reducers/accounts";
import { useNavigate } from "react-router-dom";

const DistributorStockList = () => {
  useEffect(() => {
    dispatch(getDistributorStockThunk());
  }, []);
  const navigate = useNavigate();
  const roles = useSelector((state) => state.auth.user.roles);
  const items = useSelector(distributorStockSelector.selectAll);
  const [returnOpen, setReturnOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [stock, setStock] = useState(null);

  const openMainStockReturn = (item) => {
    setReturnOpen(true);
    setStock(item);
  };
  const openTransfer = (item) => {
    setTransferOpen(true);
    setStock(item);
  };
  useEffect(() => {
    dispatch(getDistributorThunk());
  }, []);
  const distributors = useSelector((state) => state.accounts.distributors);
  const [distributor, setDistributor] = useState(null);
  useEffect(() => {
    if (distributor) {
      dispatch(getDistributorStockThunk(distributor.profile.id));
    }
  }, [distributor]);

  return (
    <Box padding={3}>
      <Stack marginBottom={2} direction="row" justifyContent="space-between">
        {roles.includes("super_admin", "admin") && (
          <Box width={300}>
            <AutoCompleteList
              items={distributors}
              name="username"
              label="Filter distributer"
              setValue={setDistributor}
              value={distributor}
            />
          </Box>
        )}
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              distributor ? `logs?distributor=${distributor.id}` : "logs"
            );
          }}
        >
          View transaction logs
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              distributor ? `history?distributor=${distributor.id}` : "history"
            );
          }}
        >
          View stock history
        </Button>
      </Stack>
      <StockListCommons
        items={items}
        openStockReturn={openMainStockReturn}
        openTransfer={openTransfer}
        stock={stock}
        returnOpen={returnOpen}
        transferOpen={transferOpen}
        setReturnOpen={setReturnOpen}
        setTransferOpen={setTransferOpen}
        ReturnStock={ReturnDistributorStock}
        TransferStock={TransferDistributorStock}
        hasEditPermissions={roles.includes("distributor")}
      />
    </Box>
  );
};

export default DistributorStockList;
